import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function PasswordConfirmField() {
  return (
    <FormField.Root name='contactPersonInfo.passwordConfirmation'>
      <Body />

      <FormField.Error />

      <FormField.Description>
        確認のために上記と同じパスワードを再度ご入力ください
      </FormField.Description>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField({
    hasDescription: true,
  });

  return (
    <InputTextV2
      required
      type='password'
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
